<script setup lang="ts">
import { PropType } from 'vue'

/* Components */
import AppButton from '@/components/App/AppButton.vue'

/* Types */
import { Popup } from '@/types/api/api-v3/popup-working'

const props = defineProps({
  popup: {
    type: Object as PropType<Popup>,
    required: true,
  },
})

const emit = defineEmits(['closePopupWorking'])

const closePopupWorking = () => {
  emit('closePopupWorking')
}
</script>
<template>
  <div class="container">
    <h2 class="container__title">{{ props.popup.title }}</h2>
    <p class="container__text">
      {{ props.popup.text }}
    </p>
    <div class="container__control">
      <app-button dimmed block class="close" @click="closePopupWorking">
        Закрыть
      </app-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  height: 100%;
  overflow: hidden;
  background: #fff;
  border-radius: 10px;

  &__title {
    max-width: 380px;
    margin: 0 auto;
    font-size: 28px;
    font-weight: 900;
    line-height: 33px;
    text-align: center;

    @include media('<tablet') {
      font-size: 24px;
      line-height: 28px;
    }
  }
  &__text {
    margin: 24px 0 30px 0;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    color: #2c2c2c;
    text-align: center;
  }

  &__control {
    width: 260px;
    margin: 0 auto;
  }
}
</style>
